import { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { SECTIONS_TRANSITION_TIMEOUT } from 'src/constants/animation.constants';
import { useGetProductsByEntitlement } from 'src/hooks/use-get-products-by-entitlement.hook';
import { AssignmentsViewOptions } from 'src/interfaces/assignment.types';
import {
  setActiveAssignmentsView,
  useCurrentGradeSelector,
} from 'src/store/features';
import { useAppDispatch } from 'src/store/redux';
import { getTheme } from 'src/utils/theme.utils';

import { ElementarySchoolAssignmentsWrapper } from '../elementary-school-assignments-wrapper';
import { ElementarySchoolAppsCard } from './elementary-school-apps-card';

import './elementary-school-apps.scss';

export const ElementarySchoolApps = ({
  animationIn,
  isSlideRight,
}: {
  animationIn: boolean;
  isSlideRight: boolean;
}) => {
  const { productsByEntitlement } = useGetProductsByEntitlement();

  const currentGrade = useCurrentGradeSelector();
  const theme = getTheme(currentGrade, false);

  const appsSectionRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    // Prevent showing the empty Apps section after class change.
    if (!productsByEntitlement.length) {
      dispatch(setActiveAssignmentsView(AssignmentsViewOptions.TODO));
    }
  }, [dispatch, productsByEntitlement]);

  return (
    <CSSTransition
      classNames={isSlideRight ? 'slide-right' : 'slide-left'}
      timeout={SECTIONS_TRANSITION_TIMEOUT}
      unmountOnExit
      in={animationIn}
      nodeRef={appsSectionRef}
    >
      <ElementarySchoolAssignmentsWrapper wrapperRef={appsSectionRef}>
        <div
          className="elementary-school-apps"
          data-testid="elementary-school-apps"
        >
          {productsByEntitlement.map((product) => (
            <ElementarySchoolAppsCard
              key={product.domain}
              theme={theme}
              product={product}
            />
          ))}
        </div>
      </ElementarySchoolAssignmentsWrapper>
    </CSSTransition>
  );
};
